import type { BlendedTrackModel } from "../../models/models";
import { AUDIO_TYPE, COLLECTION_IDS } from "../../models/dictionary";

export const blendedTracks: BlendedTrackModel[] = [
	{
		id: "52a5318b-3d12-41a6-a825-7b862732c0ed",
		slug: "sunny-day-cafe",
		name: "Sunny Day Café",
		type: AUDIO_TYPE.BLEND,
		isPremium: false,
		description:
			"A bright café hums with quiet conversation, open windows, and birdsong drifting in from outside. Let the golden light and warm atmosphere lift your mood as you work, daydream, or sip your favorite brew.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/sunny-day-cafe",
		albumId: "7090b9f9-7f65-45e7-b39a-3d71aa99ba92",
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-05-15 11:30:04+00",
		location: null,
		collectionId: COLLECTION_IDS.BLEND,
		effectIds: ["effects:creativity", "effects:focus", "effects:energy"],
		blend: [
			{
				volume: 0.6,
				trackId: "aa885b1f-42bf-4e72-b120-60386cefad02", // morning murmur
			},
			{
				volume: 0.1,
				trackId: "c3085065-43f6-4cef-a192-4dc5701fd672", // bird songs
			},
			{
				volume: 0.4,
				trackId: "8b964753-2930-42e9-b1db-8fb67a9bb200", // creek
			},
		],
	},
	{
		id: "d4f67ec4-46e2-4249-9bc2-bf3f3a3c6ae0",
		slug: "rainy-day-cafe",
		name: "Rainy Day Café",
		type: AUDIO_TYPE.BLEND,
		isPremium: true,
		description:
			"Settle into a cozy café as gentle rain taps the windows and distant thunder rolls in the background. The soft clink of cups and low conversation create the perfect ambiance for writing, reading, or deep thinking—your stormy-day sanctuary.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/rainy-day-cafe",
		albumId: "7090b9f9-7f65-45e7-b39a-3d71aa99ba92",
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-05-15 11:30:04+00",
		location: null,
		collectionId: COLLECTION_IDS.BLEND,
		effectIds: ["effects:relaxation", "effects:focus", "effects:creativity"],
		blend: [
			{
				volume: 0.6,
				trackId: "e0794e05-644b-4e18-96fd-d92741467d0b", // columbian coffeehouse
			},
			{
				volume: 0.9,
				trackId: "66f34f55-9f9d-46a9-8a80-ad269a35b7bb", // thunderstorm track
			},
		],
	},
	{
		id: "664081ee-4ee0-4494-9b27-774c6909e17c",
		slug: "little-cafe-by-the-sea",
		name: "Little Café by the Sea",
		type: AUDIO_TYPE.BLEND,
		isPremium: true,
		description:
			"Sea breeze in your hair. Waves crash nearby. Light conversation hums around sun-warmed tables. An open-air café by the coast—perfect for focused work and seaside dreaming.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/little-cafe-by-the-sea",
		albumId: "7090b9f9-7f65-45e7-b39a-3d71aa99ba92",
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-05-15 11:30:04+00",
		location: null,
		collectionId: COLLECTION_IDS.BLEND,
		effectIds: ["effects:focus", "effects:creativity", "effects:stimulation"],
		blend: [
			{
				volume: 0.15,
				trackId: "9cc4d68d-24ab-4a5f-b1fa-a7d567a4dc2a", // heavy wind
			},
			{
				volume: 0.65,
				trackId: "080a48a8-31eb-46e6-a8a4-e86b217ed065", // ocean waves
			},
			{
				volume: 0.85,
				trackId: "fb624356-91c1-455e-817c-b6d856f787f0", // paris paradise
			},
		],
	},
	{
		id: "ecc46e32-8e45-4565-99ad-ab35a31c9eae",
		slug: "storm-study-mix",
		name: "Storm Study Mix",
		type: AUDIO_TYPE.BLEND,
		isPremium: true,
		description:
			"The perfect storm for productivity—a deep rainscape laced with subtle brainwave support for immersive concentration.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/storm-study-mix",
		albumId: "7090b9f9-7f65-45e7-b39a-3d71aa99ba92",
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-05-15 11:30:04+00",
		location: null,
		collectionId: COLLECTION_IDS.BLEND,
		effectIds: ["effects:focus", "effects:productivity"],
		blend: [
			{
				volume: 0.4,
				trackId: "7c383061-2364-4b89-a83f-3e7d176cda4a", // heavy rain
			},
			{
				volume: 0.9,
				trackId: "66f34f55-9f9d-46a9-8a80-ad269a35b7bb", // thunderstorm track
			},
			{
				volume: 0.25,
				trackId: "3a765ab7-0133-42b5-8913-6c931d530322", // theta 80hz
			},
		],
	},
	{
		id: "4335a27f-f2c1-4707-a6af-100c7c81c235",
		slug: "villa-in-the-trees",
		name: "Villa in the Trees",
		type: AUDIO_TYPE.BLEND,
		isPremium: true,
		description:
			"Tap into a rhythmic, meditative state with buzzing cicadas layered beneath soft, natural ambiance.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/villa-in-the-trees",
		albumId: "7090b9f9-7f65-45e7-b39a-3d71aa99ba92",
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-05-15 11:30:04+00",
		location: null,
		collectionId: COLLECTION_IDS.BLEND,
		effectIds: ["effects:relaxation", "effects:focus", "effects:sleep"],
		blend: [
			{
				volume: 0.85,
				trackId: "98d34f56-dd50-4ace-8cf6-1cc5b98761e5", // cicadas track
			},
			{
				volume: 0.6,
				trackId: "181df085-0998-4eff-95eb-a0fe07f20b5c", // jungle
			},
			{
				volume: 0.4,
				trackId: "ec233638-51de-4440-a0c2-e9d7842df21c", // white noise
			},
		],
	},
	{
		id: "dbc24589-118f-4653-b6e1-cb61d48cf4a5",
		slug: "deltascape",
		name: "Deltascape",
		type: AUDIO_TYPE.BLEND,
		description: "",
		isPremium: true,
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/deltascape",
		albumId: "33156d32-82d5-4b0c-a3aa-5ecebe42f1ca",
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-04-30 11:30:05+00",
		location: null,
		collectionId: COLLECTION_IDS.BLEND,
		effectIds: ["effects:sleep", "effects:meditation", "effects:mindfulness"],
		blend: [
			{
				volume: 0.9,
				trackId: "d4fccf6b-4536-4c91-8f39-ec32369623fe", // "glass-sky"
			},
			{
				volume: 0.6,
				trackId: "fb6b7fd3-f96b-4441-98ca-108f8dd6f3ad", // "delta-80hz"
			},
		],
	},
	{
		id: "b14e6544-9344-49c2-b41d-14d88826cd8f",
		slug: "thetascape",
		name: "Thetascape",
		type: AUDIO_TYPE.BLEND,
		description: "",
		isPremium: true,
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/thetascape",
		albumId: "33156d32-82d5-4b0c-a3aa-5ecebe42f1ca",
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-04-30 11:30:05+00",
		location: null,
		blend: [
			{
				volume: 0.8,
				trackId: "a15ed200-c513-4acd-9fb3-acdabe6f0d3b", // "weightless"
			},
			{
				volume: 0.25,
				trackId: "0779221c-0369-4eb2-ad24-544c74985530", // "theta-200"
			},
		],
		collectionId: COLLECTION_IDS.BLEND,
		effectIds: [
			"effects:creativity",
			"effects:meditation",
			"effects:stimulation",
			"effects:focus",
		],
	},
];
